import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=77fc788a&scoped=true&"
import script from "./HomeV2.vue?vue&type=script&lang=js&"
export * from "./HomeV2.vue?vue&type=script&lang=js&"
import style0 from "./HomeV2.vue?vue&type=style&index=0&id=77fc788a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fc788a",
  null
  
)

export default component.exports